import { context } from '@ad-engine/core';

export function isDsaApplicable(useDsa: boolean): boolean {
	return useDsa && context.get('options.geoRequiresConsent');
}

export function getSampleDsaData(
	behalf = 'Acme Corporation',
	paid = 'Fandom Inc.',
	adrender: 0 | 1 = 0,
): PrebidBidResponse['meta'] {
	return {
		dsa: {
			behalf,
			paid,
			transparency: [{ domain: 'fandom.com', dsaparams: [1, 2, 3] }],
			adrender,
		},
	};
}
